<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="User Detail" @back="back">
            
        </a-page-header>

        <a-card size="small">
            <a-skeleton :loading="preload" active>
                <a-form-model
                    ref="ruleForm"
                    :model="formData"
                >
                    <a-row type="flex" :gutter="[8,8]">
                        <a-col :span="4" align="center">
                            <img :src="userInfo.photo" width="60%" style="margin-top: 20px" /><br/>
                            <a-button @click="changePhoto" style="margin-top: 20px">
                                Ganti Foto
                            </a-button>
                        </a-col>
                        <a-col :span="20">
                            <a-descriptions bordered>
                                <a-descriptions-item label="Nama">
                                    {{ userInfo.name }}
                                </a-descriptions-item>
                                <a-descriptions-item label="Email">
                                    {{ userInfo.email }}
                                </a-descriptions-item>
                                <a-descriptions-item label="Tanggal Lahir">
                                    <div v-if="!edit">
                                        <div v-if="userInfo.birthday != null">
                                            {{ moment(userInfo.birthday).format('D MMMM YYYY') }}
                                        </div>
                                    </div>
                                    <div v-else>
                                        <a-form-model-item>
                                            <a-date-picker
                                                @change="onDateChange"
                                                :format="'YYYY-MM-DD'"
                                                v-model="formData.birthday"
                                                type="date"
                                                placeholder="Pilih tanggal"
                                            />
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Tempat Lahir">
                                    <div v-if="!edit">
                                        {{ userInfo.birthplace }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="birthplace" prop="birthplace">
                                            <a-input v-model="formData.birthplace"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Jenis Kelamin">
                                    <div v-if="!edit">
                                        {{ userInfo.gender == 'L' ? 'Laki-laki' : userInfo.gender == 'P' ? 'Perempuan' : '' }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="gender" prop="gender">
                                            <a-radio-group
                                                v-model="formData.gender">
                                                <a-radio style="display: block;lineHeight: 30px;height: 30px" value="L">
                                                Laki-laki
                                                </a-radio>
                                                <a-radio style="display: block;lineHeight: 30px;height: 30px" value="P">
                                                Perempuan
                                                </a-radio>
                                            </a-radio-group>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Divisi">
                                    <div v-if="!edit">
                                        {{ userInfo.division }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="division" prop="division">
                                            <a-input v-model="formData.division"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Jabatan">
                                    <div v-if="!edit">
                                        {{ userInfo.position }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="position" prop="position">
                                            <a-input v-model="formData.position"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Alamat Kantor">
                                    <div v-if="!edit">
                                        {{ userInfo.office_address }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="office_address" prop="office_address">
                                            <a-input v-model="formData.office_address"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Telepon Kantor">
                                    <div v-if="!edit">
                                        {{ userInfo.office_phone }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="office_phone" prop="office_phone">
                                            <a-input v-model="formData.office_phone"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Alamat Rumah">
                                    <div v-if="!edit">
                                        {{ userInfo.home_address }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="home_address" prop="home_address">
                                            <a-input v-model="formData.home_address"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Telepon Rumah">
                                    <div v-if="!edit">
                                        {{ userInfo.home_phone }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="home_phone" prop="home_phone">
                                            <a-input v-model="formData.home_phone"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="No Ponsel">
                                    <div v-if="!edit">
                                        {{ userInfo.mobile_phone }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="mobile_phone" prop="mobile_phone">
                                            <a-input v-model="formData.mobile_phone"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Pendidikan">
                                    <div v-if="!edit">
                                        {{ userInfo.education }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="education" prop="education">
                                            <a-input v-model="formData.education"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Jurusan">
                                    <div v-if="!edit">
                                        {{ userInfo.majors }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="majors" prop="majors">
                                            <a-input v-model="formData.majors"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Universitas">
                                    <div v-if="!edit">
                                        {{ userInfo.university }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="university" prop="university">
                                            <a-input v-model="formData.university"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Facebook">
                                    <div v-if="!edit">
                                        {{ userInfo.facebook }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="facebook" prop="facebook">
                                            <a-input v-model="formData.facebook"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Linkedin">
                                    <div v-if="!edit">
                                        {{ userInfo.linkedin }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="linkedin" prop="linkedin">
                                            <a-input v-model="formData.linkedin"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Twitter">
                                    <div v-if="!edit">
                                        {{ userInfo.twitter }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="twitter" prop="twitter">
                                            <a-input v-model="formData.twitter"/>
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Pengalaman Kerja">
                                    <div v-if="!edit">
                                        {{ userInfo.work_experience }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="work_experience" prop="work_experience">
                                            <a-textarea v-model="formData.work_experience" />
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Hobi">
                                    <div v-if="!edit">
                                        {{ userInfo.hobby }}
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="hobby" prop="hobby">
                                            <a-textarea v-model="formData.hobby" />
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="Status Perkawinan">
                                    <div v-if="!edit">
                                        <div v-if="userInfo.family_status != 'undefined'">
                                            {{ userInfo.family_status }}
                                        </div>
                                    </div>
                                    <div v-else>
                                        <a-form-model-item ref="family_status" prop="family_status">
                                            <a-radio-group v-model="formData.family_status">
                                                <a-radio value="single">
                                                    single
                                                </a-radio>
                                                <a-radio value="married">
                                                    married
                                                </a-radio>
                                                <a-radio value="divorced">
                                                    divorced
                                                </a-radio>
                                            </a-radio-group>
                                            <!-- <a-input v-model="formData.family_status"/> -->
                                        </a-form-model-item>
                                    </div>
                                </a-descriptions-item>
                            </a-descriptions>
                        </a-col>
                    </a-row>
                    <a-row type="flex" justify="end" style="margin-top:12px">
                        <a-col>
                            <!-- <a-button @click="changePassword" style="margin-right: 10px">
                                Ganti Password
                            </a-button> -->
                            <a-button @click="editData">
                                <div v-if="!edit">
                                    Edit
                                </div>
                                <div v-else>Tutup</div>
                            </a-button>
                            <a-button
                                type="primary"
                                @click="handleSubmit"
                                :loading="processing"
                                :disabled="processing"
                                v-if="edit == true">
                                Save
                            </a-button>
                        </a-col>
                    </a-row>
                </a-form-model>
            </a-skeleton>
        </a-card>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visible"
            :closable="false"
            width= "50%"
        >
            <change-password :user_info="userInfo" @handleClose="closeModal" />
        </a-modal>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visiblePhoto"
            :closable="false"
        >
            <change-photo-form :user_info="userInfo" @handleClose="closeModal" />
        </a-modal>
    </div>
</template>

<script>
export default {
    props: {
        user_hash: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            processing: false,
            preload: false,
            visible: false,
            visiblePhoto: false,
            formData: {},
            userInfo: {},
            edit: false,
            form: this.$form.createForm(this, { name: 'coordinated' }),
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault(e);
            this.processing = true;

            this.$http.put(this.routeUri('api.users.update', {user_hash: this.user_hash}), this.formData)
            .then((response) => this.handleSuccessResponse(response.data))
            .catch((error) => this.handleResponseError(error.response.data))
            .finally(() => this.processing = false)
        },
        getItems() {
            this.preload = true;

            this.$http
                .get(this.routeUri("api.users.show", {user_hash: this.user_hash}))
                .then(response => {
                    this.formData = response.data.user;
                    this.userInfo = response.data.user;
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.preload = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => location.reload(), 1000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        editData(){
            this.edit = !this.edit
        },
        onDateChange(date, dateString) {
            this.formData.birthday = dateString
        },
        changePassword() {
            this.visible = true
        },
        changePhoto() {
            this.visiblePhoto = true
        },
        closeModal(isRefresh) {
            this.visible = false;
            this.visiblePhoto = false;

            if(isRefresh == true){
                location.reload()
            }
        },
        back(){
            window.location.href = this.routeUri('admin.setting.user.management')
        }
    }
}
</script>
